export default function( $ ) {

  /* ---------------------------------------------------- *
   *  Navigation & Slider
   * ---------------------------------------------------- */
  $( function() {
    const body = $( "body" );
    const mobileNavToggle = $( '#mobile-nav-toggle' );
    const mobileNavIcon = mobileNavToggle.find( 'i' );
    const mobileNavBackground = $( "#mobile-nav-background" );

    function toggleIcon() {
      if ( mobileNavIcon.hasClass( 'fa-bars' ) ) {
        mobileNavIcon.removeClass( 'fa-bars' ).addClass( 'fa-times' );
      } else {
        mobileNavIcon.removeClass( 'fa-times' ).addClass( 'fa-bars' );
      }
    }

    mobileNavToggle.on( 'click', function() {
      body.toggleClass( 'open-mobile-menu' );
      toggleIcon();
    } );

    mobileNavBackground.on( 'click', function( e ) {
      e.preventDefault();
      body.removeClass( 'open-mobile-menu' );
      if ( mobileNavIcon.hasClass( 'fa-times' ) ) {
        toggleIcon();
      }
    } );
  } );

  /* ---------------------------------------------------- *
   *  Navigation Large DropDown
   * ---------------------------------------------------- */
  (
    function() {
      let openmenu = 0;
      let navid = 0;
      let enterID;
      let leaveID;
      let speed = 500;

      const largeDropdown = $( '#header-large-dropdown' );
      const largeDropdownInner = $( '#header-large-dropdown-inner' );
      const mainNavigation = $( 'ul#menu-main-navigation' );

      $( '.dropdown-trigger a' ).on( 'click', function( event ) {
      } );

      $( '.dropdown-trigger' ).on( 'mouseenter touchstart', function( e ) {
        const $this = $( this );
        clearTimeout( leaveID );
        enterID = setTimeout( function() {
          if ( openmenu === 0 ) {
            largeDropdownInner.addClass( 'show' );
            openmenu = 1;
            navid = $this.attr( 'data-nav-id' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).show();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).addClass( 'active' );
          } else {
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
            navid = $this.attr( 'data-nav-id' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).show();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).addClass( 'active' );
          }
        }, speed );
      } ).on( 'mouseleave', function( e ) {
        clearTimeout( enterID );
        leaveID = setTimeout( function() {
          if ( openmenu === 1 ) {
            openmenu = 0;
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          }
        }, speed );
      } );

      largeDropdownInner.mouseenter( function() {
        clearTimeout( leaveID );
      } ).mouseleave( function() {
        leaveID = setTimeout( function() {
          if ( openmenu === 1 ) {
            openmenu = 0;
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          }
        }, speed );
      } );

      $( '#header-large-dropdown .btn-close' ).click( function( event ) {
        if ( openmenu === 1 ) {
          largeDropdownInner.removeClass( 'show' );
          largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
          mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          openmenu = 0;
          navid = 0;
        }
      } );

      $( document ).on( 'touchstart', function( e ) {
        if ( openmenu === 1 ) {
          const offset = $( '#header-large-dropdown-inner, #main-nav' ).offset();
          const offsetBottom = offset.top + $( '#header-large-dropdown-inner' ).height();
          const yPos = e.originalEvent.touches[0].pageY;
          if ( yPos < offset.top || yPos > offsetBottom ) {
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
            openmenu = 0;
            navid = 0;
          }
        }
      } );

      // Hier wird der Sticky-Effekt für das Dropdown-Menü hinzugefügt
      const header = $( '#header' ); // Beispiel-ID für den Header
      $( window ).on( 'scroll', function() {
        if ( header.hasClass( 'sticky' ) ) {
          const headerHeight = header.outerHeight();
          largeDropdownInner.css( {
            position: 'fixed',
            top: headerHeight + 'px'
          } );
        } else {
          largeDropdownInner.css( {
            position: 'fixed',
            top: 'initial'
          } );
        }
      } );
    }
  )();

  /* ---------------------------------------------------- *
   *  Navigation Mobile
   * ---------------------------------------------------- */
  (function() {
    const MOBILE_NAV_SELECTOR = '#mobile-nav';
    const MENU_ITEM_CHILDREN_SELECTOR = '.menu-item-has-children';

    // Adds a toggle element next to each menu item with children
    function appendSubmenuToggles() {
      $(`${MOBILE_NAV_SELECTOR} ${MENU_ITEM_CHILDREN_SELECTOR}`).each(function() {
        $(this).append('<i class="fa fa-caret-down submenu-toggle"></i>');
      });
    }

    // Handles the submenu toggle click event
    function handleSubmenuToggleClick(event) {
      const $toggle = $(this);
      const $parentItem = $toggle.closest(MENU_ITEM_CHILDREN_SELECTOR);
      $parentItem.toggleClass('show');

      // Toggle the arrow direction
      $toggle.toggleClass('fa-caret-down fa-caret-up');
      event.stopPropagation(); // Prevent event bubbling
    }

    // Initializes all event handlers
    function initializeMobileNav() {
      appendSubmenuToggles();

      $(MOBILE_NAV_SELECTOR)
        .on('click', '.submenu-toggle', handleSubmenuToggleClick)
        .on('click', `${MENU_ITEM_CHILDREN_SELECTOR} > a`, function(e) {
          // Links navigate normally, no special handling
        });
    }

    initializeMobileNav();
  })();
}
